export default __webpack_public_path__ + "3e421ea3bc7683e54d45156dd560e1fa.ttf";